import React, { useState } from "react";
import Box from "@mui/material/Box";

export function useForm(initialFValues, validateOnChange = false, validate) {
  const [values, setValues] = useState(initialFValues);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    let { name, value } = e.target;

    if (e.target.type === "text" || e.target.type === "textarea") {
      value = value.trimLeft();
    }

    setValues({
      ...values,
      logginError: "",
      [name]:
        name === "phone" || name === "phone_no" || name === "office_no"
          ? value.replace(/[^+\d]+/g, "")
          : name === "lat" || name === "long"
          ? value.replace(/[^.\d]/g, "").replace(/^(\d*\.?)|(\d*)\.?/g, "$1$2")
          : name === "fax"
          ? value.replace(/[^0-9]+/g, "")
          : e.target.type === "file"
          ? e.target.files[0]
          : value,
    });

    if (validateOnChange) validate({ [name]: value });
  };

  const resetForm = () => {
    setValues({ ...initialFValues, editing: values.editing });
    setErrors({});
  };

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  };
}

export function Form(props) {
  const { children, ...other } = props;

  return (
    <Box
      component="form"
      autoComplete="off"
      sx={{
        "& .MuiFormControl-root": {
          width: "80%",
          m: 1,
        },
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
